import { isSameProduct } from '~/src/common/utils/product';
import { useGetCart } from '~/src/queries/api-ecom/generated/api-ecom';

export const useGetCartProductQuantity = ({ sku, id }: { sku: string; id: string }) => {
  const { data: cart } = useGetCart();

  return cart?.products?.find(p => isSameProduct(p, { sku, id }))?.quotation2.count.quantity || 0;
};
